
import React, { Component } from 'react'
import PropTypes from "prop-types"
import { View, StyleSheet } from 'react-native'
import { JDText, JDImage, JDDevice, JDTouchable } from '@jdreact/jdreact-core-lib'
import {formatImgUrl} from '../../../utils/tools'

export default class Company extends Component{
  static contextTypes = {
		router: PropTypes.object
	};
  static propTypes = {
		companyInfo: PropTypes.object,  // 公司信息: logo + 公司名称
    venderId:PropTypes.number,      // 商家id
    handleConsult:PropTypes.func    // 立即咨询 事件
	};

  render(){
    const { companyInfo,venderId,handleConsult } = this.props
    return <View style={companyStyles.companyContainer}>
      {/* 图片 */}
      <View style={companyStyles.imgBox}>
				<JDImage style={companyStyles.headPic} source={{uri:formatImgUrl(companyInfo.companyLogo)}}></JDImage>
      </View>

      {/* 标题 */}
      <View style={[companyStyles.brokerRight]}>
        <View style={companyStyles.brokerMes}>
          <View style={[companyStyles.brokerRow,{marginBottom: JDDevice.getRpx(4),height: JDDevice.getRpx(45)}]}>
              <JDText numberOfLines={1} ellipsizeMode={'tail'} style={companyStyles.brokerName}>{companyInfo.companyDes}</JDText>
          </View> 
        </View>
      </View>

      {/* 按钮 */}
      {!!venderId && <JDTouchable style={companyStyles.telCallCon} onPress={handleConsult}>
        <View style={companyStyles.footerTelBox}><JDText style={companyStyles.footerTel}>立即咨询</JDText></View> 
      </JDTouchable>}
    </View>
  }
}

const companyStyles = StyleSheet.create({
  companyContainer:{
		display: 'flex',
		flexDirection:'row',
		width: '100%',
		height: JDDevice.getRpx(120),
		paddingBottom: JDDevice.getRpx(30),
		borderTopWidth: JDDevice.getDpx(1),
		borderStyle: 'solid',
		borderColor: '#ffffff'
	},

  imgBox: {
		position: 'relative',
		width: JDDevice.getRpx(90),
		alignItems: 'center'
	},
  headPic:{
    width:JDDevice.getRpx(90),
		height:JDDevice.getRpx(90),
		borderRadius: JDDevice.getRpx(46)
  },

  brokerRight:{
		flex:1,
		flexDirection:'row',
		marginLeft: JDDevice.getRpx(24),
		maxWidth: JDDevice.getRpx(340),
	},
	Linenew: {
		display: 'flex',
		flexDirection:'row',
		width: '100%',
		height: JDDevice.getRpx(150),
		paddingBottom: JDDevice.getRpx(30),
		paddingTop: JDDevice.getRpx(30),
		borderTopWidth: JDDevice.getDpx(1),
		borderStyle: 'solid',
		borderColor: '#E3E5E9'
	},
	brokerMes:{
		flex: 1,
		height: JDDevice.getRpx(89),
		justifyContent:"center"
	},
	brokerRow: {
		flexDirection:'row',
		alignItems: "center",
		height: JDDevice.getRpx(40),
	},
	brokerName:{
		fontSize: JDDevice.getRpx(28),
		marginRight: JDDevice.getRpx(10),
		maxWidth: JDDevice.getRpx(174),
		fontWeight: 'bold',
		color: '#424854'
	},

  footerTelBox: {
		flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
		width:JDDevice.getRpx(168),
		height:JDDevice.getRpx(88),
		borderRadius: JDDevice.getRpx(44),
		backgroundColor: '#FA2C19',
	},
  footerTel: {
		color: '#ffffff',
		fontSize: JDDevice.getRpx(32),
		textAlign: 'center',
	},
  telCallCon:{
		position: 'absolute',
		bottom: JDDevice.getRpx(30),
		right: 0
	},
})